"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgIgiThumb = props => (0, jsx_runtime_1.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 35.703,
  height: 55.224,
  ...props,
  children: [(0, jsx_runtime_1.jsx)("defs", {
    children: (0, jsx_runtime_1.jsx)("clipPath", {
      id: "igiThumb_svg__a",
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Rectangle 681",
        d: "M0 0h34.5v34.499H0z"
      })
    })
  }), (0, jsx_runtime_1.jsxs)("g", {
    "data-name": "Group 906",
    children: [(0, jsx_runtime_1.jsxs)("g", {
      "data-name": "Group 831",
      children: [(0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 788",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 461",
          d: "M5.916 52.604l-.02-12.61L8.3 39.99l.02 12.608z"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 833",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 461",
          d: "M27.405 52.604l-.02-12.61 2.403-.004.02 12.608z"
        })
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 545",
        d: "M23.85 43.625l-2.888.006a5.844 5.844 0 00-.702-.735 3.935 3.935 0 00-.743-.458 4.617 4.617 0 00-1.99-.467 4.551 4.551 0 00-3.86 2.156 4 4 0 00.031 4.266 4.673 4.673 0 001.69 1.6 4.492 4.492 0 002.26.596 4.263 4.263 0 002.903-1.14 4.4 4.4 0 00.922-1.146l-5.439.01-.004-2.19 8.478-.018.002.268a6.023 6.023 0 01-.919 3.247 6.642 6.642 0 01-2.504 2.36 7.135 7.135 0 01-3.47.872 7.148 7.148 0 01-3.49-.867 6.724 6.724 0 01-2.54-2.378 6.148 6.148 0 01-.948-3.277 6.229 6.229 0 01.925-3.31 6.762 6.762 0 012.525-2.418 7.013 7.013 0 013.46-.894 7.159 7.159 0 011.818.234 7.321 7.321 0 011.725.69 7.061 7.061 0 011.475 1.092 7.177 7.177 0 011.282 1.9z"
      })]
    }), (0, jsx_runtime_1.jsxs)("g", {
      "data-name": "logo-for-title (1)",
      children: [(0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 561",
        d: "M12.422 10.534l-3.914 2.928 8.681 7.8.024-.023h.073l8.7-7.725-3.762-2.961zm5.069 9.4l-7.35-6.611 2.925-2.178 8.637.012 3.087 2.379z",
        fill: "#8c7969"
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 562",
        d: "M13.81 11.723l-2.687 1.984 6.2 5.492 6.266-5.614-2.514-1.852zm3.658 6.508l-5.12-4.615 2.064-1.551 6.279.008 1.989 1.65z",
        fill: "#8c7969"
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 563",
        d: "M15.151 12.575l-1.85 1.309 4.029 3.6 4.143-3.635-1.673-1.267zm2.27 4.25l-3.181-2.842 1.415-1.089h3.862l1.2 1z",
        fill: "#8c7969"
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 564",
        d: "M19.817 25.707l1.274-1.13.005-3.21-1.277 1.074z",
        fill: "#8c7969"
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 565",
        d: "M13.314 25.698l1.272-1.13v-3.209l-1.279 1.074z",
        fill: "#8c7969"
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 566",
        d: "M17.19 21.258l-2.416 2.3v2.159h2.576l2.232-2.213v-1.093h-1.033l1.2-1.17h-2.463l-.062.055zm1.309 1.151L17.16 23.52h1.273v1.075h-2.4v-2.188h.129z",
        fill: "#8c7969"
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 567",
        d: "M13.286 2.509l.09-.151.09-.15.109-.182.085-.142.935-1.565 1.37 1.2.124.109.16.14.132.116.132.116.761.669.762-.666.132-.115.132-.115.16-.14.125-.109 1.373-1.2.931 1.568.081.146.108.183.089.151.09.151.517.871.932-.4.161-.069.161-.069.2-.084.152-.065 1.677-.717.4 1.779.037.162.047.207.038.171.039.171.222.988 1.01-.091.174-.016.175-.016.212-.019.164-.015 1.816-.164-.169 1.815-.015.165-.02.212-.016.175-.016.175-.094 1.009.988.225.171.039.171.039.208.047.161.037 1.778.406-.722 1.674-.066.152-.084.2-.069.161-.07.161-.4.931.87.519.15.09.151.09.182.109.142.084 1.565.935-1.2 1.37-.109.124-.14.16-.116.132-.116.132-.669.761.666.763.115.132.115.132.14.16.109.124 1.2 1.373-1.568.93-.142.084-.183.108-.151.09-.151.089-.871.517.4.932.069.162.068.161.084.2.065.152.716 1.677-1.779.4-.161.036-.208.047-.172.038-.171.039-.988.223.091 1.008.016.176.016.174.019.212.015.165.163 1.815-1.815-.169-.165-.016-.211-.019-.175-.016-.175-.016-1.01-.094-.225.987-.039.171-.039.171-.048.207-.036.161-.405 1.777-1.674-.721-.151-.065-.2-.084-.161-.07-.161-.069-.93-.4-.52.869-.09.151-.09.151-.11.183-.085.142-.935 1.565-1.369-1.2-.124-.109-.16-.141-.132-.116-.132-.116-.76-.668-.763.667-.132.116-.132.115-.16.14-.125.109-1.373 1.2-.93-1.568-.084-.141-.109-.184-.089-.151-.089-.151-.517-.871-.931.4-.161.069-.167.047-.2.084-.152.065-1.677.716-.4-1.779-.036-.161-.047-.208-.038-.171-.038-.171-.222-.988-1.009.091-.175.016-.175.016-.212.019-.165.015-1.816.163.169-1.815.015-.165.02-.212.016-.174.017-.175.094-1.008-.987-.226-.171-.039-.171-.039-.207-.047-.161-.037-1.772-.401.722-1.674.065-.152.084-.2.069-.161.07-.161.4-.93-.869-.52-.15-.09-.151-.09-.183-.109-.142-.085L.32 19.9l1.2-1.369.109-.124.14-.16.116-.132.116-.132.669-.755-.667-.763-.115-.132-.115-.132-.14-.16-.109-.125-1.2-1.373 1.568-.931.142-.084.183-.108.151-.09.151-.09.871-.517-.4-.931-.069-.161-.069-.161-.084-.2-.065-.152-.717-1.677 1.778-.4.161-.036.208-.047.172-.038.171-.038.988-.222-.091-1.009-.016-.175-.016-.175-.019-.212-.015-.165-.164-1.816 1.815.169.165.016.212.019.175.016.175.016 1.009.094.225-.987.039-.171.039-.171.047-.207.036-.161.405-1.778 1.675.722.152.065.2.084.161.069.161.069.93.4zM14.545 0l-1.06 1.773-.085.141-1.391-.876-.613 1.528-.151-.065-1.9-.818-.459 2.014-.037.161-1.6-.408-.111 1.643-.165-.015-2.057-.192.185 2.057.015.165-1.644.106.4 1.6-.161.036-2.015.454.812 1.9.065.152-1.531.609.877 1.395-.142.084L0 14.498l1.37 1.55.109.125-1.268 1.052L1.47 18.28l-.109.124L0 19.955l1.77 1.059.142.085-.881 1.392 1.529.613-.065.152-.818 1.9 2.014.46.161.037-.408 1.6 1.644.111-.016.165-.191 2.056 2.057-.185.165-.015.105 1.644 1.6-.4.036.161.453 2.016 1.9-.812.152-.065.609 1.531 1.395-.877.084.142 1.054 1.776 1.556-1.359.125-.109 1.052 1.267 1.056-1.264.124.109 1.551 1.364 1.059-1.773.084-.141 1.392.881.613-1.53.152.066 1.9.817.459-2.014.037-.161 1.6.408.111-1.644.164.015 2.057.191-.185-2.057-.015-.165 1.644-.106-.4-1.6.161-.036 2.015-.454-.812-1.9-.065-.152 1.524-.616-.88-1.392.142-.084 1.776-1.054-1.359-1.555-.109-.124 1.268-1.052-1.264-1.055.109-.124 1.363-1.551-1.773-1.06-.141-.085.888-1.394-1.529-.613.066-.152.818-1.9-2.014-.46-.161-.037.408-1.6-1.643-.111.015-.165.192-2.057-2.058.185-.165.015-.111-1.635-1.6.4-.037-.161-.453-2.016-1.9.812-.153.065-.608-1.531-1.395.877-.084-.142-1.05-1.774-1.556 1.36-.125.108L17.276.209l-1.055 1.264-.124-.109z",
        fill: "#8c7969"
      }), (0, jsx_runtime_1.jsxs)("g", {
        "data-name": "Group 870",
        children: [(0, jsx_runtime_1.jsx)("g", {
          "data-name": "Group 867",
          clipPath: "url(#igiThumb_svg__a)",
          children: (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 568",
            d: "M32.762 18.759l-.109-.124-.14-.161-.116-.132-.115-.132-.82-.939.824-.937.116-.131.116-.132.14-.16.109-.124.99-1.127-1.288-.77-.142-.084-.183-.109-.151-.09-.15-.09-1.07-.639.493-1.145.07-.161.069-.161.084-.195.065-.152.594-1.378-1.463-.334-.161-.037-.208-.047-.171-.039-.171-.039-1.215-.277.115-1.241.016-.174.016-.175.02-.212.015-.165.139-1.493-1.493.134-.166.011-.212.019-.175.016-.174.016-1.242.112-.274-1.216-.038-.171-.039-.171-.046-.205-.036-.161-.329-1.463-1.38.59-.152.065-.2.084-.161.069-.161.069-1.147.49-.634-1.074-.089-.151-.089-.151-.108-.182-.084-.142-.766-1.29-1.129.987-.124.109-.16.14-.132.115-.132.115-.938.82-.937-.824-.132-.115-.132-.116-.16-.14-.124-.109-1.126-.99-.769 1.288-.085.142-.109.183-.09.15-.09.151-.639 1.071-1.145-.494-.161-.07-.16-.066-.2-.084-.152-.065-1.377-.594-.334 1.462-.037.161-.047.208-.039.171-.039.171-.277 1.215-1.241-.116-.175-.016-.175-.016-.212-.02-.165-.015-1.494-.139.135 1.494.015.165.019.212.016.175.016.175.112 1.242-1.216.274-.171.039-.171.038-.208.047-.161.036-1.463.329.589 1.379.065.152.084.2.069.162.069.161.49 1.147-1.072.636-.151.089-.151.09-.183.108-.142.085-1.29.766.987 1.13.109.125.14.16.115.132.115.132.82.939-.823.936-.116.132-.116.132-.14.16-.109.124-.99 1.127 1.287.769.142.085.183.109.151.09.15.09 1.071.639-.493 1.145-.07.162-.069.161-.084.2-.065.152-.594 1.378 1.462.334.161.037.208.048.171.039.171.039 1.216.277-.116 1.222-.017.176-.016.174-.02.212-.015.165-.132 1.493 1.494-.135.165-.015.212-.019.175-.016.175-.016 1.241-.112.274 1.216.038.171.039.171.047.208.036.161.329 1.464 1.379-.589.152-.065.2-.084.161-.069.161-.069 1.146-.49.636 1.072.09.151.09.151.109.183.084.142.766 1.29 1.13-.987.125-.109.16-.14.132-.115.132-.115.939-.821.936.823.132.115.132.116.16.141.124.109 1.126.991.77-1.288.085-.141.109-.183.09-.151.09-.151.639-1.069 1.145.493.161.07.161.069.2.084.152.065 1.378.594.334-1.462.037-.161.047-.208.039-.171.039-.171.277-1.215 1.242.116.175.017.175.016.212.02.164.015 1.493.14-.134-1.494-.015-.165-.019-.212-.016-.174-.016-.176-.112-1.241 1.216-.274.17-.039.172-.038.208-.047.161-.036 1.464-.329-.589-1.379-.065-.152-.083-.2-.069-.161-.069-.162-.49-1.146 1.072-.636.151-.089.151-.09.183-.108.142-.084 1.29-.765zM3.53 17.229a13.72 13.72 0 1113.7 13.741 13.72 13.72 0 01-13.7-13.741",
            fill: "#8c7969"
          })
        }), (0, jsx_runtime_1.jsx)("g", {
          "data-name": "Group 868",
          clipPath: "url(#igiThumb_svg__a)",
          children: (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 569",
            d: "M30.382 17.27a13.127 13.127 0 10-13.151 13.107A13.142 13.142 0 0030.382 17.27m-26.049-.04a12.921 12.921 0 1112.9 12.94 12.936 12.936 0 01-12.9-12.94",
            fill: "#8c7969"
          })
        }), (0, jsx_runtime_1.jsx)("g", {
          "data-name": "Group 869",
          clipPath: "url(#igiThumb_svg__a)",
          children: (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 570",
            d: "M17.214 21.235l-.024.023.036.032.062-.055z",
            fill: "#8c7969"
          })
        })]
      }), (0, jsx_runtime_1.jsxs)("g", {
        "data-name": "Group 871",
        fill: "#8d7967",
        children: [(0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 571",
          d: "M15.304 29.012h-.34v-1.539h-.315v-.267h.655z"
        }), (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 572",
          d: "M16.443 29.011h-.368l.409-.615-.079.014a.406.406 0 01-.058 0 .481.481 0 01-.376-.177.636.636 0 01-.154-.433.6.6 0 01.042-.213.692.692 0 01.113-.2.63.63 0 01.215-.169.682.682 0 01.515-.007.616.616 0 01.2.136.637.637 0 01.137.2.58.58 0 01.048.231.748.748 0 01-.052.27 1.986 1.986 0 01-.2.36zm.308-1.192a.329.329 0 00-.087-.23.273.273 0 00-.208-.095.278.278 0 00-.212.089.348.348 0 000 .451.272.272 0 00.208.088.287.287 0 00.212-.089.294.294 0 00.086-.213z"
        }), (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 573",
          d: "M17.73 29.012h-.361l.673-1.488h-.706v-.317h1.033v.335z"
        })]
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 872",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 574",
          d: "M19.653 27.206v.312h-.62l-.056.31a.473.473 0 01.118-.048.514.514 0 01.13-.016.563.563 0 01.425.186.657.657 0 01.134.676.657.657 0 01-.121.2.636.636 0 01-.218.168.623.623 0 01-.265.056.607.607 0 01-.433-.167.647.647 0 01-.2-.433h.34a.312.312 0 00.1.2.274.274 0 00.195.076.265.265 0 00.206-.092.337.337 0 00.083-.234.314.314 0 00-.083-.226.292.292 0 00-.22-.086.284.284 0 00-.141.033.246.246 0 00-.095.1l-.3-.068.172-.94z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 873",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 575",
          d: "M11.61 25.684l-1.015 1.466-.279-.193 1.015-1.466z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 874",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 576",
          d: "M10.953 25.231l-1.2 1.317-.282-.257.305-1.444.03-.055-.9.985-.253-.231 1.2-1.317.28.256-.3 1.438-.026.059.894-.979z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 875",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 577",
          d: "M9.448 23.752l-1.139.919.212.263-.249.2-.641-.793.249-.2.215.266 1.139-.919z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 876",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 578",
          d: "M8.852 22.983l-1.517.938-.518-.838.272-.168.34.549.35-.216-.324-.524.272-.168.324.525.35-.217-.34-.549.272-.168z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 877",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 579",
          d: "M8.151 21.808l-1.636.711-.212-.487a1.164 1.164 0 01-.087-.27.514.514 0 01.012-.216.562.562 0 01.119-.222.545.545 0 01.2-.149.582.582 0 01.21-.045.569.569 0 01.209.028.482.482 0 01.145.08.784.784 0 01.144.151l.406-.718.167.384-.436.713.627-.272zm-.993.061l-.074-.17a.432.432 0 00-.169-.215.233.233 0 00-.218-.005.242.242 0 00-.145.171.274.274 0 000 .112.735.735 0 00.05.145l.075.173z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 878",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 580",
          d: "M7.555 20.387l-1.732.427-.091-.37 1.057-1.031.055-.029-1.3.319-.082-.333 1.732-.427.091.368-1.05 1.029-.054.034 1.288-.317z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 879",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 581",
          d: "M7.152 18.681l-1.822-.666-.014-.266 1.74-.867.02.373-.448.223.035.65.47.179zm-.781-.625l-.024-.447-.544.244-.066.012h.067z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 880",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 582",
          d: "M7.113 16.411l-1.457-.142-.033.336-.319-.031.1-1.015.318.031-.034.341 1.457.142z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 881",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 583",
          d: "M7.238 15.462l-1.75-.345.066-.333 1.75.345z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 882",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 584",
          d: "M5.962 13.261a1 1 0 01.282-.422.924.924 0 01.437-.219.9.9 0 01.487.037.885.885 0 01.395.277.934.934 0 01.2.443.987.987 0 01-.323.9.939.939 0 01-.436.216.907.907 0 01-.876-.311.952.952 0 01-.206-.439.913.913 0 01.04-.482zm.311.08a.647.647 0 00-.032.326.6.6 0 00.13.287.585.585 0 00.261.181.593.593 0 00.317.024.627.627 0 00.288-.137.6.6 0 00.205-.576.628.628 0 00-.137-.289.589.589 0 00-.259-.182.581.581 0 00-.31-.023.625.625 0 00-.284.135.582.582 0 00-.183.258z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 883",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 585",
          d: "M8.157 12.657l-1.527-.919.2-.326 1.477.015.06.018-1.143-.687.177-.294 1.528.919-.2.325-1.471-.011-.063-.014 1.136.683z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 884",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 586",
          d: "M9.09 11.152l-.819-1.757.178-.2 1.844.612-.25.279-.475-.158-.435.485.206.458zm-.112-.994l.3-.334-.558-.211-.055-.038.044.05z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 885",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 587",
          d: "M10.506 9.642l-1.13-1.378.263-.215.927 1.13.433-.355.2.247z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 886",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 588",
          d: "M13.178 6.553l-.369.174a.828.828 0 00-.134-.052.556.556 0 00-.123-.015.653.653 0 00-.282.06.643.643 0 00-.366.508.565.565 0 00.26.545.661.661 0 00.312.1.635.635 0 00.325-.059.6.6 0 00.3-.32.622.622 0 00.049-.2l-.7.328-.132-.28 1.085-.511.016.034a.852.852 0 01.077.471.939.939 0 01-.179.452 1.046 1.046 0 01-.891.418.951.951 0 01-.468-.152.869.869 0 01-.318-.363.881.881 0 01-.08-.479.956.956 0 01.178-.461.992.992 0 01.389-.322 1.012 1.012 0 01.247-.079 1.036 1.036 0 01.262-.015 1 1 0 01.255.051 1.015 1.015 0 01.287.167z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 887",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 589",
          d: "M14.115 7.577l-.47-1.719.951-.26.084.308-.623.17.108.4.6-.163.084.308-.6.163.108.4.623-.17.084.308z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 888",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 590",
          d: "M15.431 7.222l-.153-1.775.461-.04.606 1.273.03.1.012-.108.341-1.354.461-.04.153 1.775-.339.029-.114-1.33-.36 1.371-.287.025-.586-1.289.114 1.33z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 889",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 591",
          d: "M18.811 5.386a1 1 0 01.472.188.923.923 0 01.3.382.9.9 0 01.065.483.886.886 0 01-.189.444.937.937 0 01-.392.288.989.989 0 01-.951-.127.938.938 0 01-.3-.381.9.9 0 01.123-.921.953.953 0 01.388-.293.915.915 0 01.484-.063zm-.013.321a.646.646 0 00-.326.037.594.594 0 00-.254.186.6.6 0 00-.081.607.625.625 0 00.194.253.6.6 0 00.607.081.635.635 0 00.255-.194.59.59 0 00.124-.291.578.578 0 00-.042-.308.617.617 0 00-.191-.249.578.578 0 00-.287-.122z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 890",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 592",
          d: "M19.869 7.448l.526-1.7.325.1-.432 1.4.535.165-.095.306z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 891",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 593",
          d: "M22.568 6.536a1 1 0 01.385.331.922.922 0 01.164.46.9.9 0 01-.1.478.883.883 0 01-.323.358.935.935 0 01-.464.146.988.988 0 01-.858-.429.939.939 0 01-.161-.458.885.885 0 01.093-.473.894.894 0 01.323-.358.954.954 0 01.461-.151.917.917 0 01.48.096zm-.117.3a.646.646 0 00-.32-.071.6.6 0 00-.3.094.586.586 0 00-.211.237.593.593 0 00-.062.311.622.622 0 00.1.3.6.6 0 00.548.274.633.633 0 00.3-.1.589.589 0 00.212-.235.579.579 0 00.061-.3.621.621 0 00-.1-.3.577.577 0 00-.233-.211z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 892",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 594",
          d: "M25.091 8.91l-.319-.254a.87.87 0 00-.012-.143.56.56 0 00-.041-.117.653.653 0 00-.178-.227.643.643 0 00-.618-.1.566.566 0 00-.375.474.658.658 0 00.045.326.636.636 0 00.2.265.605.605 0 00.421.131.628.628 0 00.2-.045l-.6-.479.194-.242.937.747-.024.03a.855.855 0 01-.389.277.939.939 0 01-.485.039 1.042 1.042 0 01-.768-.614.946.946 0 01-.07-.487.868.868 0 01.186-.445.882.882 0 01.4-.284.956.956 0 01.493-.044 1.008 1.008 0 01.64.393 1.03 1.03 0 01.13.228.861.861 0 01.039.574z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 893",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 595",
          d: "M24.567 10.213l1.3-1.216.232.248-1.305 1.216z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 894",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 596",
          d: "M26.274 11.584l.227.324a1.272 1.272 0 01-.174.016.807.807 0 01-.145-.014.991.991 0 01-.438-.216.977.977 0 01-.166-.182.937.937 0 01-.168-.462.948.948 0 01.08-.482.9.9 0 01.309-.373.884.884 0 01.452-.16.955.955 0 01.849.405.981.981 0 01.153.345.951.951 0 01.013.372.663.663 0 01-.034.14 1.468 1.468 0 01-.078.166l-.222-.317a.942.942 0 00.019-.142.668.668 0 00-.113-.379.577.577 0 00-.241-.2.621.621 0 00-.31-.053.59.59 0 00-.3.107.582.582 0 00-.2.242.63.63 0 00-.056.311.579.579 0 00.1.294.588.588 0 00.168.16.635.635 0 00.118.059.984.984 0 00.157.039z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 895",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 597",
          d: "M26.17 12.31l1.94-.025.108.244-1.318 1.428-.152-.342.34-.368-.264-.6h-.5zm.953.307l.181.409.422-.422.057-.034-.064.02z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 896",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 598",
          d: "M26.946 14.235l1.722-.467.089.328-1.413.383.146.54-.309.084z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 897",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 599",
          d: "M27.358 16.211l1.777-.153.029.338-1.777.153z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 898",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 600",
          d: "M27.428 17.013l1.781.087-.019.38-1.308.686-.062.012 1.332.065-.017.343-1.782-.087.019-.379 1.3-.686.062-.018-1.325-.064z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 899",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 601",
          d: "M27.795 18.892l-.075.348a.234.234 0 00-.178.038.255.255 0 00-.1.161.244.244 0 00.027.184.216.216 0 00.146.1.229.229 0 00.2-.043.709.709 0 00.159-.206l.038-.067a.924.924 0 01.1-.134.5.5 0 01.212-.132.475.475 0 01.248-.012.469.469 0 01.231.124.515.515 0 01.138.23.552.552 0 01.009.276.573.573 0 01-.12.251.5.5 0 01-.217.15.546.546 0 01-.272.022l.074-.342a.2.2 0 00.146-.034.206.206 0 00.079-.129.173.173 0 00-.023-.139.184.184 0 00-.12-.077.17.17 0 00-.136.023.5.5 0 00-.129.156l-.041.072a.967.967 0 01-.193.244.487.487 0 01-.431.105.55.55 0 01-.266-.138.564.564 0 01-.157-.255.605.605 0 01-.011-.308.6.6 0 01.264-.39.494.494 0 01.194-.078.537.537 0 01.204 0z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 900",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 602",
          d: "M26.892 20.459l1.38.485.112-.319.3.106-.339.962-.3-.106.114-.323-1.38-.485z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 901",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 603",
          d: "M26.54 21.362l1.617.752-.143.308-1.617-.752z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 902",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 604",
          d: "M26.088 22.241l1.254.754.175-.289.274.165-.527.874-.274-.165.177-.293-1.254-.754z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 903",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 605",
          d: "M27.005 24.169l-.211.266-.872-.69a1.378 1.378 0 00-.123-.09.3.3 0 00-.087-.033.278.278 0 00-.15.01.257.257 0 00-.119.084.275.275 0 00-.056.126.254.254 0 00.011.135.275.275 0 00.054.094 1.046 1.046 0 00.124.11l.872.69-.213.269-.872-.69a1.07 1.07 0 01-.2-.2.535.535 0 01-.089-.205.629.629 0 010-.276.58.58 0 01.318-.408.685.685 0 01.26-.074.533.533 0 01.23.036 1.081 1.081 0 01.251.157z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 904",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 606",
          d: "M24.378 24.495l1.009 1.058.245-.233.221.232-.739.7-.221-.232.248-.236-1.008-1.055z",
          fill: "#8d7967"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Group 905",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 607",
          d: "M23.659 25.133l1.057 1.434-.794.584-.19-.257.52-.383-.244-.331-.5.366-.19-.258.5-.366-.245-.331-.52.383-.19-.257z",
          fill: "#8d7967"
        })
      })]
    })]
  })]
});
exports.default = SvgIgiThumb;